import 'date-input-polyfill-react'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import React, { useEffect, useState } from 'react'

import styles from './Dialog.module.sass'
import useSession from 'hooks/useSession'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'

const ResetPasswordDialog = (props) => {
	const { i18n, pushNotification } = useGlobal()
	const { className, resolve, dismiss } = props
	const [passwords, setPasswords] = useState({})
	const [submitting, setSubmitting] = useState(false)
	const { error, changePassword, resetState } = useSession()
	const [dialogError, setDialogError] = useState(null)

	const { oldPassword, newPassword, newPasswordConfirmation } = passwords

	const handleSubmit = (e) => {
		e.preventDefault()
		setSubmitting(true)
		changePassword(passwords).then((r) => {
			setSubmitting(false)
			if (r) {
				resolve && resolve()
				pushNotification(
					undefined,
					'success',
					i18n`Password changed successfully!`
				)
			}
		})
	}

	useEffect(() => {
		if (error || dialogError) {
			setDialogError([
				error.message || i18n.translate(`${error[0]?.message}`),
			])
		}
		//eslint-disable-next-line
	}, [error, i18n])

	const handleInputChange = (e) => {
		setDialogError(null)
		resetState(false, true, true)
		const target = e.target
		const name = e.target.name
		setPasswords((prevState) => ({
			...prevState,
			[name]: target.value,
		}))
	}
	return (
		<>
			<TaskHeaderErrors errors={dialogError || []} />
			<form
				id={'form_reset_password'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
			>
				<fieldset>
					<small className={styles['dialog-title']}>
						{i18n`Fill the old password and create a new one`}
					</small>
					<TextInput
						className={styles['text-input']}
						type='password'
						name='oldPassword'
						placeholder={i18n`Old Password`}
						required
						value={oldPassword}
						onChange={handleInputChange}
					/>
					<TextInput
						className={styles['text-input']}
						type='password'
						name='newPassword'
						placeholder={i18n`New Password`}
						required
						value={newPassword}
						onChange={handleInputChange}
					/>
					<TextInput
						className={styles['text-input']}
						type='password'
						name='newPasswordConfirmation'
						placeholder={i18n`New Password Confirmation`}
						required
						value={newPasswordConfirmation}
						onChange={handleInputChange}
					/>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={'form_reset_password'} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Submit`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default ResetPasswordDialog
